/** @jsxImportSource theme-ui */

import React from 'react';
import { ResponsiveStyleValue } from 'theme-ui';
import { colors } from '../../tokens';
import { CarrotTheme } from '../../theme';
import { BadgeVariantProp } from '../../theme/custom/badges';

type BadgeColorScheme = keyof typeof badgeColorSchemeStyles;
export interface BadgeProps extends BadgeOverrideProps {
    colorScheme?: BadgeColorScheme;
    size?: BadgeVariantProp;
    children: React.ReactNode | React.ReactNodeArray;
}
interface BadgeOverrideProps {
    backgroundColor?: ResponsiveStyleValue<keyof typeof colors.base>;
    color?: ResponsiveStyleValue<keyof typeof colors.base>;
}

const badgeColorSchemeStyles = {
    gray: {
        backgroundColor: (theme: CarrotTheme) => theme.colors.lightGrey,
        color: (theme: CarrotTheme) => theme.colors.black80,
    },
    red: {
        backgroundColor: (theme: CarrotTheme) => theme.colors.lightRed,
        color: (theme: CarrotTheme) => theme.colors.errorRed,
    },
    yellow: {
        backgroundColor: (theme: CarrotTheme) => theme.colors.lightCarrotOrange,
        color: (theme: CarrotTheme) => theme.colors.darkCarrotOrange,
    },
    green: {
        backgroundColor: (theme: CarrotTheme) => theme.colors.mint,
        color: (theme: CarrotTheme) => theme.colors.darkGreen,
    },
};

export function Badge({ children, colorScheme, color, backgroundColor, size }: BadgeProps): JSX.Element {
    const override = {} as BadgeOverrideProps;
    const badgeColorSchemeStyle = badgeColorSchemeStyles[colorScheme];
    if (color) {
        override.color = color;
    }
    if (backgroundColor) {
        override.backgroundColor = backgroundColor;
    }
    return (
        <span
            sx={{
                variant: `badges.${size}`,
                display: 'inline-block',
                textTransform: 'uppercase',
                borderRadius: '3px;',
                fontFamily: (theme: CarrotTheme) => theme.fonts.gotham,
                ...badgeColorSchemeStyle,
                ...override,
            }}
        >
            {children}
        </span>
    );
}

Badge.defaultProps = {
    colorScheme: 'gray',
    size: 'medium',
};
